import { css } from 'styled-components'
import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'


const content = css`
  a {
    color: ${variables.LINK_TXC};
    display: inline-block;

    &.is-hover {
      opacity: .7;
    }

    &[href^="tel:"] {
      text-decoration: underline;

      ${minMq('MD')} {
        pointer-events: none;
      }
    }
  }
  
  p + p {
    margin-top: 10px;
  }
`

const subTitle01 = css`
  border-left: 6px solid ${variables.THEME_C};
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.6;
  margin-bottom: 15px;
  margin-top: 20px;
  padding-left: 7px;

  ${minMq('MD')} {
    font-size: 1.8rem;
    line-height: 36px;
  }
`

const subTitle02 = css`
  color: ${variables.THEME_C};
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 5px;
  margin-top: 10px;
  
  ${minMq('MD')} {
    font-size: 1.8rem;
  }
`

const subTitle03 = css`
  color: ${variables.BASE_TXC};
  font-weight: 700;
  margin-bottom: 5px;
  margin-top: 10px;
`

const catchTxt = css`
  background-color: ${variables.LIGHT_BLUE};
  color: ${variables.THEME_C};
  font-weight: 700;
  margin-bottom: 10px;
  margin-top: 20px;
  padding: 10px;
`

const notetTxt = css`
  font-size: 85%;
  margin-bottom: 5px;
  margin-top: 5px;
`

const imgCap = css`
  font-size: 85%;
  line-height: 1.5;
  margin-bottom: 15px;
`

const list = css`
  margin: 10px 0;
  > li {
    margin-left: 1em;
    text-indent: -1em;

    &:before {
      content: "・";
    }
  }
`

const olList = css`
  > li {
    margin-left: 2em;
    text-indent: -1.6em;
  }
`

const img = (maxW: number, margin = "15px 0") => css`
  margin: ${margin};
  ${maxW ? `max-width: ${maxW}px` : ""};
  width: 100%;
`

const emphasisWeight = css`
  font-weight: 700;
`

const emphasisColor = css`
  color: ${variables.RED};
`

export const style = {
  content,
  subTitle01,
  subTitle02,
  subTitle03,
  catchTxt,
  notetTxt,
  imgCap,
  list,
  olList,
  img,
  emphasisWeight,
  emphasisColor
}
